import { lighten } from "colorizr"
import { generateGradientColors } from "../utils/visuals"

export const useTQRCodeVisuals = (
  eventPrimaryColor: string,
  isCheckedIn: boolean,
) => {
  const checkedInGradientColors = ["#27AE60", "#2ECC71", "#66D89E"]

  const gradientColors = isCheckedIn
    ? checkedInGradientColors
    : generateGradientColors(eventPrimaryColor)

  const primaryColor = isCheckedIn ? "#27AE60" : eventPrimaryColor || "#4299E1"

  const primaryColorLighter = lighten(primaryColor, 25)

  return {
    gradientColors,
    primaryColor,
    primaryColorLighter,
    checkedInGradientColors,
  }
}

export default useTQRCodeVisuals
